import SwaggerUI from "swagger-ui-react"
import "swagger-ui-react/swagger-ui.css"
import apiSpec from '../benepay-b2b-api.json';

const Swagger = () => <SwaggerUI spec={apiSpec} />

export default Swagger;